<!--
 * @Description: 常规工作/日常事务 教学设计
 * @Author: PF
 * @Date: 2022-12-28 10:43:25
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:19:49
-->
<template>
  <el-dialog class="wp80 hp90" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close style="min-width:1200px">
    <template #header>
      <div class="header-left">
        <el-icon class="header-icon">
          <Edit />
        </el-icon>
        <span class="header-title">教学工作</span>
      </div>
      <div class="header-right">
        <el-button type="info" text @click="openList = false; homeCloseWindow('openReturn', emits, false)">
          <el-icon>
            <Close />
          </el-icon>
        </el-button>
      </div>
    </template>
    <el-container>
      <el-header class="pl0 pr0">
        <!-- 搜索区域 -->
        <div class="top_search mb10">
          <!-- @change="xveqichaxvn" -->
          <el-select class="filter-item mr10" v-model="xqid" placeholder="学期">
            <el-option v-for="(item) in allXq" :key="item.id" @click="xveqichaxvn(item)" :label="item.xqmc" :value="item.id" />
          </el-select>
          <el-select v-model="zcid" class="filter-item" placeholder="周次" style="width:100px" @change="zhouci">
            <el-option v-for="item in allzc" :key="item.id" :label="'第' + item.zc + '周'" :value="item.zc" />
          </el-select>
        </div>
        <div class="top_but">
          <div class="but_group" style="flex-wrap: wrap;">
            <el-button class="ml0 mr10 mb10" type="primary" @click="activeName='jxsj'; handleChange()">上传教学设计</el-button>
            <el-button class="ml0 mr10 mb10" type="primary" @click="activeName='kj'; handleChange()">上传课件</el-button>
            <el-button class="ml0 mr10 mb10" type="primary" @click="activeName='bk'; handleChange()">备课</el-button>
            <el-button class="ml0 mr10 mb10" type="primary" @click="activeName='jzrz'; handleChange()">上传教学日志</el-button>
            <el-button class="ml0 mr10 mb10" type="primary" @click="activeName='bzzy'; handleChange()">布置作业</el-button>
          </div>
          <div class="top_total">
            <span class="mr10">本学期必须上传的教学工作：{{ bxscs }} </span>
            <span class="mr10">已上传的教学设计：{{yjscs}}</span>
            <span class="mr10">已上传的课件：{{ysckjs}}</span>
            <span class="mr10">已上传的备课：{{ybks}}</span>
            <span class="mr10">已上传的教学日志：{{yscjxrzs}}</span>
            <span class="mr10">已布置的作业：{{ybzzys}}</span>
          </div>
        </div>
      </el-header>
      <el-main class="pl0 pr0">
        <el-table v-loading="loading" :data="tableData" :span-method="dSpanCellMerge" border height="100%" style="width: 100%;">
          <el-table-column label="时段" align="center" width="46px">
            <template #default="scope">
              <p style="writing-mode: tb-rl;" v-if="scope.row.sd == 1">上 午</p>
              <p style="writing-mode: tb-rl;" v-if="scope.row.sd == 2">下 午</p>
              <p style="writing-mode: tb-rl;" v-if="scope.row.sd == 3">晚 上</p>
            </template>
          </el-table-column>
          <el-table-column prop="amount1" label="节次" align="center" width="80px">
            <template #default="scope">
              <span>第{{ scope.row.xq1.jc }}节</span>
            </template>
          </el-table-column>
          <el-table-column prop="kssj" label="上课时间" align="center" width="90px">
            <template #default="scope">
              <span>{{ scope.row.kssj }}</span>
            </template>
          </el-table-column>
          <el-table-column label="星期一" align="center">
            <template #default="scope">
              <div class="table-div" v-if="scope.row.xq1.kcmc">
                <div class="table-div-checked">
                  <el-checkbox v-model="scope.row.xq1.Checkbox" :disabled="scope.row.xq1.sfscjxsj===true && scope.row.xq1.sfsckj == true && scope.row.xq1.sfscjxrz == true && scope.row.xq1.sfbeike == true && scope.row.xq1.sftjbeike == 2" />
                </div>
                <div class="table-div-span">
                  <p>{{ scope.row.xq1.kcmc }}</p>
                  <p>{{ scope.row.xq1.bjmc }}</p>
                  <p>{{ scope.row.xq1.jxcdmcs }}</p>
                  <p>教学设计:
                    <span v-if="scope.row.xq1.sfscjxsj===false">未上传</span>
                    <!-- <span v-if="scope.row.xq1.jxsjtjzt == 1">已提交</span> -->
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq1.sfscjxsj===true && scope.row.xq1.jxsjtjzt!==1" @click="openEditJxsj=true;row={id:scope.row.xq1.jxsjid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq1.sfscjxsj===true" @click="openDetailJxsj=true;row={id:scope.row.xq1.jxsjid}">查看</el-link>
                    <span v-if="scope.row.xq1.zt == 3">不合格</span>
                  </p>
                  <p>课件:
                    <!-- 状态：0-未提交，1-已提交，2-合格，3-不合格 -->
                    <span v-if="scope.row.xq1.sfsckj == false || scope.row.xq1.sfsckj == null">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq1.sfsckj===true&&scope.row.xq1.kjtjzt!==1" @click="openEditKj=true;row=scope.row.xq1">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq1.sfsckj == true" @click="chakan(scope.row.xq1)">查看</el-link>
                  </p>
                  <p>备课:
                    <!-- 状态：0-未上传，1-已上传，2-已提交 -->
                    <span v-if="scope.row.xq1.sfbeike == false && scope.row.xq1.sftjbeike == 0">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq1.sfbeike===true && scope.row.xq1.sftjbeike == 1" @click="openEditBk=true;row={id:scope.row.xq1.beikeid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="(scope.row.xq1.sfbeike == true && scope.row.xq1.sftjbeike == 2) || scope.row.xq1.sftjbeike == 1" @click="openDetailBk = true; row = {id:scope.row.xq1.beikeid}">查看</el-link>
                  </p>
                  <p>教学日志:
                    <span v-if="scope.row.xq1.sfscjxrz == false || scope.row.xq1.sfscjxrz == null">未上传</span>
                    <!-- <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq1.sfscjxrz===true" @click="openEditJxrz=true;row=scope.row.xq1">修改</el-link> -->
                    <el-link type="success" :underline="false" v-if="scope.row.xq1.sfscjxrz == true" @click="openDetailJxrz = true; row = scope.row.xq1">查看</el-link>
                  </p>
                  <p>布置作业:
                    <span v-if="scope.row.xq1.sfbzzy == false || scope.row.xq1.sfbzzy == null">未上传</span>
                    <el-link type="success" :underline="false" v-if="scope.row.xq1.sfbzzy == true" @click="openDetailbzzy = true; row = scope.row.xq1">查看</el-link>
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="星期二" align="center">
            <template #default="scope">
              <div class="table-div" v-if="scope.row.xq2.kcmc">
                <div class="table-div-checked">
                  <el-checkbox v-model="scope.row.xq2.Checkbox" :disabled="scope.row.xq2.sfscjxsj===true && scope.row.xq2.sfsckj == true && scope.row.xq2.sfscjxrz == true && scope.row.xq2.sfbeike == true && scope.row.xq2.sftjbeike == 2" />
                </div>
                <div class="table-div-span">
                  <p>{{ scope.row.xq2.kcmc }}</p>
                  <p>{{ scope.row.xq2.bjmc }}</p>
                  <p>{{ scope.row.xq2.jxcdmcs }}</p>
                  <p>教学设计:
                    <span v-if="scope.row.xq2.sfscjxsj===false">未上传</span>
                    <!-- <span v-if="scope.row.xq2.jxsjtjzt == 1">已提交</span> -->
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq2.sfscjxsj===true && scope.row.xq2.jxsjtjzt!==1" @click="openEditJxsj=true;row={id:scope.row.xq2.jxsjid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq2.sfscjxsj===true" @click="openDetailJxsj=true;row={id:scope.row.xq2.jxsjid}">查看</el-link>
                    <span v-if="scope.row.xq2.zt == 3">不合格</span>
                  </p>
                  <p>课件:
                    <span v-if="scope.row.xq2.sfsckj == false || scope.row.xq2.sfsckj == null">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq2.sfsckj===true&&scope.row.xq2.kjtjzt!==1" @click="openEditKj=true;row=scope.row.xq2">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq2.sfsckj == true" @click="chakan(scope.row.xq2)">查看</el-link>
                  </p>
                  <p>备课:
                    <span v-if="scope.row.xq2.sfbeike == false && scope.row.xq2.sftjbeike == 0">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq2.sfbeike===true && scope.row.xq2.sftjbeike == 1" @click="openEditBk=true;row={id:scope.row.xq2.beikeid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="(scope.row.xq2.sfbeike == true && scope.row.xq2.sftjbeike == 2) || scope.row.xq2.sftjbeike == 1" @click="openDetailBk = true; row = {id:scope.row.xq2.beikeid}">查看</el-link>
                  </p>
                </div>
                <p>教学日志:
                  <span v-if="scope.row.xq2.sfscjxrz == false || scope.row.xq2.sfscjxrz == null">未上传</span>
                  <!-- <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq2.sfscjxrz===true" @click="openEditJxrz=true;row=scope.row.xq2">修改</el-link> -->
                  <el-link type="success" :underline="false" v-if="scope.row.xq2.sfscjxrz == true" @click="openDetailJxrz = true; row = scope.row.xq2">查看</el-link>
                </p>
                <p>布置作业:
                  <span v-if="scope.row.xq2.sfbzzy == false || scope.row.xq2.sfbzzy == null">未上传</span>
                  <el-link type="success" :underline="false" v-if="scope.row.xq2.sfbzzy == true" @click="openDetailbzzy = true; row = scope.row.xq2">查看</el-link>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="星期三" align="center">
            <template #default="scope">
              <div class="table-div" v-if="scope.row.xq3.kcmc">
                <div class="table-div-checked">
                  <el-checkbox v-model="scope.row.xq3.Checkbox" :disabled="scope.row.xq3.sfscjxsj===true && scope.row.xq3.sfsckj == true && scope.row.xq3.sfscjxrz == true && scope.row.xq3.sfbeike == true && scope.row.xq3.sftjbeike == 2" />
                </div>
                <div class="table-div-span">
                  <p>{{ scope.row.xq3.kcmc }}</p>
                  <p>{{ scope.row.xq3.bjmc }}</p>
                  <p>{{ scope.row.xq3.jxcdmcs }}</p>
                  <p>教学设计:
                    <span v-if="scope.row.xq3.sfscjxsj===false">未上传</span>
                    <!-- <span v-if="scope.row.xq3.jxsjtjzt == 1">已提交</span> -->
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq3.sfscjxsj===true && scope.row.xq3.jxsjtjzt!==1" @click="openEditJxsj=true;row={id:scope.row.xq3.jxsjid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq3.sfscjxsj===true" @click="openDetailJxsj=true;row={id:scope.row.xq3.jxsjid}">查看</el-link>
                    <span v-if="scope.row.xq3.zt == 3">不合格</span>
                  </p>
                  <p>课件:
                    <!-- 状态：0-未提交，1-已提交，2-合格，3-不合格 -->
                    <span v-if="scope.row.xq3.sfsckj == false || scope.row.xq3.sfsckj == null">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq3.sfsckj===true&&scope.row.xq3.kjtjzt!==1" @click="openEditKj=true;row=scope.row.xq3">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq3.sfsckj == true" @click="chakan(scope.row.xq3)">查看</el-link>
                  </p>
                  <p>备课:
                    <!-- 状态：0-未上传，1-已上传，2-已提交 -->
                    <span v-if="scope.row.xq3.sfbeike == false && scope.row.xq3.sftjbeike == 0">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq3.sfbeike===true && scope.row.xq3.sftjbeike == 1" @click="openEditBk=true;row={id:scope.row.xq3.beikeid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="(scope.row.xq3.sfbeike == true && scope.row.xq3.sftjbeike == 2) || scope.row.xq3.sftjbeike == 1" @click="openDetailBk = true; row = {id:scope.row.xq3.beikeid}">查看</el-link>
                  </p>
                  <p>教学日志:
                    <span v-if="scope.row.xq3.sfscjxrz == false || scope.row.xq3.sfscjxrz == null">未上传</span>
                    <!-- <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq3.sfscjxrz===true" @click="openEditJxrz=true;row=scope.row.xq3">修改</el-link> -->
                    <el-link type="success" :underline="false" v-if="scope.row.xq3.sfscjxrz == true" @click="openDetailJxrz = true; row = scope.row.xq3">查看</el-link>
                  </p>
                  <p>布置作业:
                    <span v-if="scope.row.xq3.sfbzzy == false || scope.row.xq3.sfbzzy == null">未上传</span>
                    <el-link type="success" :underline="false" v-if="scope.row.xq3.sfbzzy == true" @click="openDetailbzzy = true; row = scope.row.xq3">查看</el-link>
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="星期四" align="center">
            <template #default="scope">
              <div class="table-div" v-if="scope.row.xq4.kcmc">
                <div class="table-div-checked">
                  <el-checkbox v-model="scope.row.xq4.Checkbox" :disabled="scope.row.xq4.sfscjxsj===true && scope.row.xq4.sfsckj == true && scope.row.xq4.sfscjxrz == true && scope.row.xq4.sfbeike == true && scope.row.xq4.sftjbeike == 2" />
                </div>
                <div class="table-div-span">
                  <p>{{ scope.row.xq4.kcmc }}</p>
                  <p>{{ scope.row.xq4.bjmc }}</p>
                  <p>{{ scope.row.xq4.jxcdmcs }}</p>
                  <p>教学设计:
                    <span v-if="scope.row.xq4.sfscjxsj===false">未上传</span>
                    <!-- <span v-if="scope.row.xq4.jxsjtjzt == 1">已提交</span> -->
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq4.sfscjxsj===true && scope.row.xq4.jxsjtjzt!==1" @click="openEditJxsj=true;row={id:scope.row.xq4.jxsjid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq4.sfscjxsj===true" @click="openDetailJxsj=true;row={id:scope.row.xq4.jxsjid}">查看</el-link>
                    <span v-if="scope.row.xq4.zt == 3">不合格</span>
                  </p>
                  <p>课件:
                    <!-- 状态：0-未提交，1-已提交，2-合格，3-不合格 -->
                    <span v-if="scope.row.xq4.sfsckj == false || scope.row.xq4.sfsckj == null">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq4.sfsckj===true&&scope.row.xq4.kjtjzt!==1" @click="openEditKj=true;row=scope.row.xq4">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq4.sfsckj == true" @click="chakan(scope.row.xq4)">查看</el-link>
                  </p>
                  <p>备课:
                    <!-- 状态：0-未上传，1-已上传，2-已提交 -->
                    <span v-if="scope.row.xq4.sfbeike == false && scope.row.xq4.sftjbeike == 0">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq4.sfbeike===true && scope.row.xq4.sftjbeike == 1" @click="openEditBk=true;row={id:scope.row.xq4.beikeid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="(scope.row.xq4.sfbeike == true && scope.row.xq4.sftjbeike == 2) || scope.row.xq4.sftjbeike == 1" @click="openDetailBk = true; row = {id:scope.row.xq4.beikeid}">查看</el-link>
                  </p>
                  <p>教学日志:
                    <span v-if="scope.row.xq4.sfscjxrz == false || scope.row.xq4.sfscjxrz == null">未上传</span>
                    <!-- <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq4.sfscjxrz===true" @click="openEditJxrz=true;row=scope.row.xq4">修改</el-link> -->
                    <el-link type="success" :underline="false" v-if="scope.row.xq4.sfscjxrz == true" @click="openDetailJxrz = true; row = scope.row.xq4">查看</el-link>
                  </p>
                  <p>布置作业:
                    <span v-if="scope.row.xq4.sfbzzy == false || scope.row.xq4.sfbzzy == null">未上传</span>
                    <el-link type="success" :underline="false" v-if="scope.row.xq4.sfbzzy == true" @click="openDetailbzzy = true; row = scope.row.xq4">查看</el-link>
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="星期五" align="center">
            <template #default="scope">
              <div class="table-div" v-if="scope.row.xq5.kcmc">
                <div class="table-div-checked">
                  <el-checkbox v-model="scope.row.xq5.Checkbox" :disabled="scope.row.xq5.sfscjxsj===true && scope.row.xq5.sfsckj == true && scope.row.xq5.sfscjxrz == true && scope.row.xq5.sfbeike == true && scope.row.xq5.sftjbeike == 2" />
                </div>
                <div class="table-div-span">
                  <p>{{ scope.row.xq5.kcmc }}</p>
                  <p>{{ scope.row.xq5.bjmc }}</p>
                  <p>{{ scope.row.xq5.jxcdmcs }}</p>
                  <p>教学设计:
                    <span v-if="scope.row.xq5.sfscjxsj===false">未上传</span>
                    <!-- <span v-if="scope.row.xq5.jxsjtjzt == 1">已提交</span> -->
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq5.sfscjxsj===true && scope.row.xq5.jxsjtjzt!==1" @click="openEditJxsj=true;row={id:scope.row.xq5.jxsjid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq5.sfscjxsj===true" @click="openDetailJxsj=true;row={id:scope.row.xq5.jxsjid}">查看</el-link>
                    <span v-if="scope.row.xq5.zt == 3">不合格</span>
                  </p>
                  <p>课件:
                    <!-- 状态：0-未提交，1-已提交，2-合格，3-不合格 -->
                    <span v-if="scope.row.xq5.sfsckj == false || scope.row.xq5.sfsckj == null">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq5.sfsckj===true&&scope.row.xq5.kjtjzt!==1" @click="openEditKj=true;row=scope.row.xq5">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq5.sfsckj == true" @click="chakan(scope.row.xq5)">查看</el-link>
                  </p>
                  <p>备课:
                    <!-- 状态：0-未上传，1-已上传，2-已提交 -->
                    <span v-if="scope.row.xq5.sfbeike == false && scope.row.xq5.sftjbeike == 0">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq5.sfbeike===true && scope.row.xq5.sftjbeike == 1" @click="openEditBk=true;row={id:scope.row.xq5.beikeid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="(scope.row.xq5.sfbeike == true && scope.row.xq5.sftjbeike == 2) || scope.row.xq5.sftjbeike == 1" @click="openDetailBk = true; row = {id:scope.row.xq5.beikeid}">查看</el-link>
                  </p>
                  <p>教学日志:
                    <span v-if="scope.row.xq5.sfscjxrz == false || scope.row.xq5.sfscjxrz == null">未上传</span>
                    <!-- <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq5.sfscjxrz===true" @click="openEditJxrz=true;row=scope.row.xq5">修改</el-link> -->
                    <el-link type="success" :underline="false" v-if="scope.row.xq5.sfscjxrz == true" @click="openDetailJxrz = true; row = scope.row.xq5">查看</el-link>
                  </p>
                  <p>布置作业:
                    <span v-if="scope.row.xq5.sfbzzy == false || scope.row.xq5.sfbzzy == null">未上传</span>
                    <el-link type="success" :underline="false" v-if="scope.row.xq5.sfbzzy == true" @click="openDetailbzzy = true; row = scope.row.xq5">查看</el-link>
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="星期六" align="center">
            <template #default="scope">
              <div class="table-div" v-if="scope.row.xq6.kcmc">
                <div class="table-div-checked">
                  <el-checkbox v-model="scope.row.xq6.Checkbox" :disabled="scope.row.xq6.sfscjxsj===true && scope.row.xq6.sfsckj == true && scope.row.xq6.sfscjxrz == true && scope.row.xq6.sfbeike == true && scope.row.xq6.sftjbeike == 2" />
                </div>
                <div class="table-div-span">
                  <p>{{ scope.row.xq6.kcmc }}</p>
                  <p>{{ scope.row.xq6.bjmc }}</p>
                  <p>{{ scope.row.xq6.jxcdmcs }}</p>
                  <p>教学设计:
                    <span v-if="scope.row.xq6.sfscjxsj===false">未上传</span>
                    <!-- <span v-if="scope.row.xq6.jxsjtjzt == 1">已提交</span> -->
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq6.sfscjxsj===true && scope.row.xq6.jxsjtjzt!==1" @click="openEditJxsj=true;row={id:scope.row.xq6.jxsjid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq6.sfscjxsj===true" @click="openDetailJxsj=true;row={id:scope.row.xq6.jxsjid}">查看</el-link>
                    <span v-if="scope.row.xq6.zt == 3">不合格</span>
                  </p>
                  <p>课件:
                    <!-- 状态：0-未提交，1-已提交，2-合格，3-不合格 -->
                    <span v-if="scope.row.xq6.sfsckj == false || scope.row.xq6.sfsckj == null">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq6.sfsckj===true&&scope.row.xq6.kjtjzt!==1" @click="openEditKj=true;row=scope.row.xq6">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq6.sfsckj == true" @click="chakan(scope.row.xq6)">查看</el-link>
                  </p>
                  <p>备课:
                    <!-- 状态：0-未上传，1-已上传，2-已提交 -->
                    <span v-if="scope.row.xq6.sfbeike == false && scope.row.xq6.sftjbeike == 0">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq6.sfbeike===true && scope.row.xq6.sftjbeike == 1" @click="openEditBk=true;row={id:scope.row.xq6.beikeid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="(scope.row.xq6.sfbeike == true && scope.row.xq6.sftjbeike == 2) || scope.row.xq6.sftjbeike == 1" @click="openDetailBk = true; row = {id:scope.row.xq6.beikeid}">查看</el-link>
                  </p>
                  <p>教学日志:
                    <span v-if="scope.row.xq6.sfscjxrz == false || scope.row.xq6.sfscjxrz == null">未上传</span>
                    <!-- <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq6.sfscjxrz===true" @click="openEditJxrz=true;row=scope.row.xq6">修改</el-link> -->
                    <el-link type="success" :underline="false" v-if="scope.row.xq6.sfscjxrz == true" @click="openDetailJxrz = true; row = scope.row.xq6">查看</el-link>
                  </p>
                  <p>布置作业:
                    <span v-if="scope.row.xq6.sfbzzy == false || scope.row.xq6.sfbzzy == null">未上传</span>
                    <el-link type="success" :underline="false" v-if="scope.row.xq6.sfbzzy == true" @click="openDetailbzzy = true; row = scope.row.xq6">查看</el-link>
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="星期日" align="center">
            <template #default="scope">
              <div class="table-div" v-if="scope.row.xq7.kcmc">
                <div class="table-div-checked">
                  <el-checkbox v-model="scope.row.xq7.Checkbox" :disabled="scope.row.xq7.sfscjxsj===true && scope.row.xq7.sfsckj == true && scope.row.xq7.sfscjxrz == true && scope.row.xq7.sfbeike == true && scope.row.xq7.sftjbeike == 2" />
                </div>
                <div class="table-div-span">
                  <p>{{ scope.row.xq7.kcmc }}</p>
                  <p>{{ scope.row.xq7.bjmc }}</p>
                  <p>{{ scope.row.xq7.jxcdmcs }}</p>
                  <p>教学设计:
                    <span v-if="scope.row.xq7.sfscjxsj===false">未上传</span>
                    <!-- <span v-if="scope.row.xq7.jxsjtjzt == 1">已提交</span> -->
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq7.sfscjxsj===true && scope.row.xq7.jxsjtjzt!==1" @click="openEditJxsj=true;row={id:scope.row.xq7.jxsjid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq7.sfscjxsj===true" @click="openDetailJxsj=true;row={id:scope.row.xq7.jxsjid}">查看</el-link>
                    <span v-if="scope.row.xq7.zt == 3">不合格</span>
                  </p>
                  <p>课件:
                    <!-- 状态：0-未提交，1-已提交，2-合格，3-不合格 -->
                    <span v-if="scope.row.xq7.sfsckj == false || scope.row.xq7.sfsckj == null">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq7.sfsckj===true&&scope.row.xq7.kjtjzt!==1" @click="openEditKj=true;row=scope.row.xq7">修改</el-link>
                    <el-link type="success" :underline="false" v-if="scope.row.xq7.sfsckj == true" @click="chakan(scope.row.xq7)">查看</el-link>
                  </p>
                  <p>备课:
                    <!-- 状态：0-未上传，1-已上传，2-已提交 -->
                    <span v-if="scope.row.xq7.sfbeike == false && scope.row.xq7.sftjbeike == 0">未上传</span>
                    <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq7.sfbeike===true && scope.row.xq7.sftjbeike == 1" @click="openEditBk=true;row={id:scope.row.xq7.beikeid}">修改</el-link>
                    <el-link type="success" :underline="false" v-if="(scope.row.xq7.sfbeike == true && scope.row.xq7.sftjbeike == 2) || scope.row.xq7.sftjbeike == 1" @click="openDetailBk = true; row = {id:scope.row.xq7.beikeid}">查看</el-link>
                  </p>
                  <p>教学日志:
                    <span v-if="scope.row.xq7.sfscjxrz == false || scope.row.xq7.sfscjxrz == null">未上传</span>
                    <!-- <el-link class="mr5" type="primary" :underline="false" v-if="scope.row.xq7.sfscjxrz===true" @click="openEditJxrz=true;row=scope.row.xq7">修改</el-link> -->
                    <el-link type="success" :underline="false" v-if="scope.row.xq7.sfscjxrz == true" @click="openDetailJxrz = true; row = scope.row.xq7">查看</el-link>
                  </p>
                  <p>布置作业:
                    <span v-if="scope.row.xq7.sfbzzy == false || scope.row.xq7.sfbzzy == null">未上传</span>
                    <el-link type="success" :underline="false" v-if="scope.row.xq7.sfbzzy == true" @click="openDetailbzzy = true; row = scope.row.xq7">查看</el-link>
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </el-dialog>
  <!-- 上传教学设计 BEGIN  -->
  <el-dialog class="w850 hp85" v-model="openAddJiaoXueSheJi" title="上传教学设计" :before-close="handleClose">
    <addjiaoxuesheji v-if="openAddJiaoXueSheJi" :openAdd="openAddJiaoXueSheJi" :row="row" :chechboxtrue="chechboxtrue" @guanBi="handleClose" @ReturnData="getjslistdata()" />
  </el-dialog>
  <editjiaoxuesheji v-if="openEditJxsj" v-model:openEdit="openEditJxsj" :row="row" @ReturnData="getjslistdata()" />
  <detailjiaoxuesheji v-if="openDetailJxsj" v-model:openDetail="openDetailJxsj" :row="row" />
  <!-- 上传教学设计 END  -->
  <!-- 上传课件 BEGIN  -->
  <el-dialog class="w850 hp85" v-model="openAddKeJian" title="上传课件" :before-close="handleClose">
    <addkejian v-if="openAddKeJian" :openAdd="openAddKeJian" :row="row" :chechboxtrue="chechboxtrue" @guanBi="handleClose" @ReturnData="getjslistdata()" />
  </el-dialog>
  <editkejian v-if="openEditKj" v-model:openEdit="openEditKj" :row="row" @ReturnData="getjslistdata()" />
  <detailkejian v-if="openDetailKj" v-model:openDetail="openDetailKj" :row="row" />
  <!-- 上传课件 END  -->
  <!-- 布置作业 BEGIN  -->
  <el-dialog class="w850 hp85" v-model="openAddBuZhiZuoYe" title="布置作业" :before-close="handleClose">
    <addbuzhizuoye v-if="openAddBuZhiZuoYe" :openAdd="openAddBuZhiZuoYe" :row="row" :chechboxtrue="chechboxtrue" @guanBi="handleClose" @ReturnData="getjslistdata()" />
  </el-dialog>
  <detailbuzhizuoye v-if="openDetailbzzy" v-model:openDetail="openDetailbzzy" :row="row" />
  <!-- 布置作业 END  -->
  <!-- 上传教学日志 BEGIN  -->
  <el-dialog class="w850 hp85" v-model="openAddJiaoXueRiZhi" title="上传教学日志" :before-close="handleClose">
    <addjiaoxuerizhi v-if="openAddJiaoXueRiZhi" :openAdd="openAddJiaoXueRiZhi" :row="row" :chechboxtrue="chechboxtrue" @guanBi="handleClose" @ReturnData="getjslistdata()" />
  </el-dialog>
  <detailjiaoxuerizhi v-if="openDetailJxrz" v-model:openDetail="openDetailJxrz" :row="row" @ReturnData="getjslistdata()" />
  <!-- 上传教学日志 END  -->
  <!-- 备课 BEGIN  -->
  <el-dialog class="w850 hp85" v-model="openAddBeike" title="备课" :before-close="handleClose">
    <addbeike v-if="openAddBeike" :openAdd="openAddBeike" :row="row" :chechboxtrue="chechboxtrue" @guanBi="handleClose" @ReturnData="getjslistdata()" />
  </el-dialog>
  <editbeike v-if="openEditBk" v-model:openEdit="openEditBk" :row="row" @ReturnData="getjslistdata()" />
  <detailbeike v-if="openDetailBk" v-model:openDetail="openDetailBk" :row="row" />
  <!-- 备课 END  -->

  <!-- 上传 BEGIN  -->
  <el-dialog class="w1000 hp85" v-model="openAdd" title="上传" :before-close="handleClose">
    <el-container>
      <el-header class="pl0 pr0">
        <el-tabs v-model="activeName" @tab-change="handleChange()">
          <el-tab-pane label="上传教学设计" name="jxsj"></el-tab-pane>
          <el-tab-pane label="上传课件" name="kj"></el-tab-pane>
          <el-tab-pane label="备课" name="bk"></el-tab-pane>
          <el-tab-pane label="上传教学日志" name="jzrz"></el-tab-pane>
          <el-tab-pane label="布置作业" name="bzzy"></el-tab-pane>
        </el-tabs>
      </el-header>
      <el-main class="pl0 pr0 pb0">
        <!-- 教学设计 -->
        <addjiaoxuesheji v-if="openAddJxsj" :openAdd="openAddJxsj" :row="row" :chechboxtrue="chechboxtrue" @guanBi="handleClose" @ReturnData="getjslistdata()" />
        <!-- 课件 -->
        <addkejian v-if="openAddKj" :openAdd="openAddKj" :row="row" :chechboxtrue="chechboxtrue" @guanBi="handleClose" @ReturnData="getjslistdata()" />
        <!-- 布置作业 -->
        <addbuzhizuoye v-if="openAddBzzy" :openAdd="openAddBzzy" :row="row" :chechboxtrue="chechboxtrue" @guanBi="handleClose" @ReturnData="getjslistdata()" />
        <!-- 教学日志 -->
        <addjiaoxuerizhi v-if="openAddJxrz" :openAdd="openAddJxrz" :row="row" @guanBi="handleClose" @ReturnData="getjslistdata()" />
        <!-- 备课 -->
        <addbeike v-if="openAddBk" :openAdd="openAddBk" :row="row" :chechboxtrue="chechboxtrue" @guanBi="handleClose" @ReturnData="getjslistdata()" />
      </el-main>
    </el-container>
  </el-dialog>
  <!-- 上传 END  -->
</template>

<script setup>
import { defineProps, watch, defineEmits, ref } from 'vue'
import { loadSelect, actionPost, homeCloseWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo'
import { getDate } from '@/utils/index'
// 教学设计
import addjiaoxuesheji from './addjiaoxuesheji.vue'
import editjiaoxuesheji from './editjiaoxuesheji.vue'
import detailjiaoxuesheji from './detailjiaoxuesheji.vue'
// 课件
import addkejian from './addkejian.vue'
import editkejian from './editkejian.vue'
import detailkejian from './detailkejian.vue'
// 布置作业
import addbuzhizuoye from './addbuzhizuoye.vue'
import detailbuzhizuoye from './detailbuzhizuoye.vue'
// 教学日志
import addjiaoxuerizhi from './addjiaoxuerizhi.vue'
import detailjiaoxuerizhi from './detailjiaoxuerizhi.vue'
// 备课
import addbeike from './addbeike.vue'
import editbeike from './editbeike.vue'
import detailbeike from './detailbeike.vue'

const props = defineProps({
  open: { type: String, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['openReturn', 'ReturnData'])

const openAdd = ref(false)
const activeName = ref('jxsj')
const handleChange = () => {
  openAddJxsj.value = false
  openAddKj.value = false
  openAddBzzy.value = false
  openAddJxrz.value = false
  openAddBk.value = false
  switch (activeName.value) {
    case 'jxsj':
      addjxsj(2)
      break
    case 'kj':
      addkj(2)
      break
    case 'bzzy':
      addzy(2)
      break
    case 'jzrz':
      addjxrz(2)
      break
    case 'bk':
      addbk(2)
      break
  }
}

const handleClose = () => {
  openAddJiaoXueSheJi.value = false
  openAddKeJian.value = false
  openAddBuZhiZuoYe.value = false
  openAddJiaoXueRiZhi.value = false
  openAddBeike.value = false
  openAdd.value = false
  openAddJxsj.value = false
  openAddKj.value = false
  openAddBzzy.value = false
  openAddJxrz.value = false
  openAddBk.value = false
}

// 内容区域
const row = ref()
const xqid = ref() // 学期id
const xqmc = ref() // 学期名称
const zcid = ref() // 周次id
const allXq = ref() // 学期数据
const allzc = ref() // 周次
const tableData = ref() // 课表结构
const merge = ref() // 存放需要合并的行
const pos = ref() // 需要合并行下标
const jslistdata = ref() // 教师数据
const chechboxtrue = ref() // 选中的数据
const loading = ref(false) // 加载
const kcids = ref([]) // 课程ID
const truebox = ref([])

// 弹窗


// 查看课件
const chakan = (e) => {
  openDetailKj.value = true
  row.value = {
    id: e.id,
    xlbjkbid: e.xlbjkbid,
    kjid: e.kjid,
    xqid: xqid.value,
    xqmc: xqmc.value,
    zc: zcid.value,
    kcmc: e.kcmc,
    bjmc: e.bjmc,
    jc: e.jc,
    xq: e.xq
  }
}
// 获取学期数据
const getxqlist = () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: allXq,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          xqid.value = element.id
          xqmc.value = element.xqmc
        }
      })
      getzouci()
    }
  })
}
// 课表结构
const getkebiaojiegou = () => {
  const o = { url: '/api/v2/jiaowu/jiaowukebiaojiegou/list', data: {} }
  actionPost(o).then((res) => {
    res.data.xqRow.forEach((element) => {
      if (jslistdata.value) {
        jslistdata.value.forEach((item) => {
          if (item.xq === 1) {
            if (element.xq1.jc === item.jc) {
              element.xq1 = item
              element.xq1.Checkbox = false
            }
          }
          if (item.xq === 2) {
            if (element.xq2.jc === item.jc) {
              element.xq2 = item
              element.xq2.Checkbox = false
            }
          }
          if (item.xq === 3) {
            if (element.xq3.jc === item.jc) {
              element.xq3 = item
              element.xq3.Checkbox = false
            }
          }
          if (item.xq === 4) {
            if (element.xq4.jc === item.jc) {
              element.xq4 = item
              element.xq4.Checkbox = false
            }
          }
          if (item.xq === 5) {
            if (element.xq5.jc === item.jc) {
              element.xq5 = item
              element.xq5.Checkbox = false
            }
          }
          if (item.xq === 6) {
            if (element.xq6.jc === item.jc) {
              element.xq6 = item
              element.xq6.Checkbox = false
            }
          }
          if (item.xq === 7) {
            if (element.xq7.jc === item.jc) {
              element.xq7 = item
              element.xq7.Checkbox = false
            }
          }
        })
      }
    })
    tableData.value = res.data.xqRow
    xvk(res.data.xqRow)
  })
}
// 上传课件
const openAddKj = ref(false)
const openAddKeJian = ref(false)
const openEditKj = ref(false)
const openDetailKj = ref(false)
const addkj = (val) => {
  const truebox = []
  tableData.value.forEach((element) => {
    if (element.xq1.Checkbox === true) {
      truebox.push(element.xq1)
    }
    if (element.xq2.Checkbox === true) {
      truebox.push(element.xq2)
    }
    if (element.xq3.Checkbox === true) {
      truebox.push(element.xq3)
    }
    if (element.xq4.Checkbox === true) {
      truebox.push(element.xq4)
    }
    if (element.xq5.Checkbox === true) {
      truebox.push(element.xq5)
    }
    if (element.xq6.Checkbox === true) {
      truebox.push(element.xq6)
    }
    if (element.xq7.Checkbox === true) {
      truebox.push(element.xq7)
    }
  })
  const kcid = []
  truebox.forEach((jskc) => {
    kcid.push(jskc.kcid)
  })
  if (kcid.length <= 0) {
    warningPrompt('请选择课程')
    return false
  }
  let istrue = true
  const leng = kcid.length
  if (leng > 0) {
    for (let i = 0; i < leng; i++) {
      if (kcid.indexOf(kcid[i]) !== 0) {
        istrue = false
      }
    }
  }
  if (istrue) {
    chechboxtrue.value = truebox
    if (val === 1) {
      openAddKeJian.value = true
    } else {
      openAdd.value = true
      openAddKj.value = true
    }
    row.value = {
      title: '上传课件',
      xqid: xqid.value,
      xqmc: xqmc.value,
      zc: zcid.value,
      chechboxtrue: truebox
    }
  } else {
    warningPrompt('课程必须相同')
    return false
  }
}
// 上传教学设计
const openAddJxsj = ref(false)
const openAddJiaoXueSheJi = ref(false)
const openEditJxsj = ref(false)
const openDetailJxsj = ref(false)
const addjxsj = (item) => {
  const truebox = []
  tableData.value.forEach((element) => {
    if (element.xq1.Checkbox === true) {
      truebox.push(element.xq1)
    }
    if (element.xq2.Checkbox === true) {
      truebox.push(element.xq2)
    }
    if (element.xq3.Checkbox === true) {
      truebox.push(element.xq3)
    }
    if (element.xq4.Checkbox === true) {
      truebox.push(element.xq4)
    }
    if (element.xq5.Checkbox === true) {
      truebox.push(element.xq5)
    }
    if (element.xq6.Checkbox === true) {
      truebox.push(element.xq6)
    }
    if (element.xq7.Checkbox === true) {
      truebox.push(element.xq7)
    }
  })
  const kcid = []
  try {
    truebox.forEach((jskc) => {
      if (jskc.sfscjxsj === false) {
        kcid.push(jskc.kcid)
      } else {
        throw element
      }
    })
  } catch (error) {
    return warningPrompt('教学设计已上传')
  }
  if (kcid.length <= 0) {
    warningPrompt('请选择课程')
    return false
  }

  let istrue = true
  const leng = kcid.length
  if (leng > 0) {
    for (let i = 0; i < leng; i++) {
      if (kcid.indexOf(kcid[i]) !== 0) {
        istrue = false
      }
    }
  }
  if (istrue) {
    chechboxtrue.value = truebox
    if (item === 1) {
      openAddJiaoXueSheJi.value = true
    } else {
      openAdd.value = true
      openAddJxsj.value = true
    }
    row.value = {
      title: '上传教学设计',
      xqid: xqid.value,
      xqmc: xqmc.value,
      zc: zcid.value,
      chechboxtrue: truebox
    }
  } else {
    warningPrompt('课程必须相同')
    return false
  }
}
// 备课
const openAddBk = ref(false)
const openAddBeike = ref(false)
const openEditBk = ref(false)
const openDetailBk = ref(false)
const addbk = (val) => {
  const truebox = []
  tableData.value.forEach((element) => {
    if (element.xq1.Checkbox === true) {
      truebox.push(element.xq1)
    }
    if (element.xq2.Checkbox === true) {
      truebox.push(element.xq2)
    }
    if (element.xq3.Checkbox === true) {
      truebox.push(element.xq3)
    }
    if (element.xq4.Checkbox === true) {
      truebox.push(element.xq4)
    }
    if (element.xq5.Checkbox === true) {
      truebox.push(element.xq5)
    }
    if (element.xq6.Checkbox === true) {
      truebox.push(element.xq6)
    }
    if (element.xq7.Checkbox === true) {
      truebox.push(element.xq7)
    }
  })
  const kcid = []
  try {
    truebox.forEach((jskc) => {
      if (jskc.sfbeike === false) {
        kcid.push(jskc.kcid)
      } else {
        throw element
      }
    })
  } catch (error) {
    return warningPrompt('备课已上传')
  }
  if (kcid.length <= 0) {
    warningPrompt('请选择课程')
    return false
  }

  let istrue = true
  const leng = kcid.length
  if (leng > 0) {
    for (let i = 0; i < leng; i++) {
      if (kcid.indexOf(kcid[i]) !== 0) {
        istrue = false
      }
    }
  }
  if (istrue) {
    chechboxtrue.value = truebox
    if (val === 1) {
      openAddBeike.value = true
    } else {
      openAdd.value = true
      openAddBk.value = true
    }
    row.value = {
      title: '上传备课',
      xqid: xqid.value,
      xqmc: xqmc.value,
      zc: zcid.value,
      chechboxtrue: truebox
    }
  } else {
    warningPrompt('课程必须相同')
    return false
  }
}
// 获取已选课程
const huoQuYiXuanKeCheng = () => {
  truebox.value = []
  tableData.value.forEach((element) => {
    if (element.xq1.Checkbox === true) {
      element.xq1.kssj = element.kssj
      element.xq1.jssj = element.jssj
      truebox.value.push(element.xq1)
    }
    if (element.xq2.Checkbox === true) {
      element.xq2.kssj = element.kssj
      element.xq2.jssj = element.jssj
      truebox.value.push(element.xq2)
    }
    if (element.xq3.Checkbox === true) {
      element.xq3.kssj = element.kssj
      element.xq3.jssj = element.jssj
      truebox.value.push(element.xq3)
    }
    if (element.xq4.Checkbox === true) {
      element.xq4.kssj = element.kssj
      element.xq4.jssj = element.jssj
      truebox.value.push(element.xq4)
    }
    if (element.xq5.Checkbox === true) {
      element.xq5.kssj = element.kssj
      element.xq5.jssj = element.jssj
      truebox.value.push(element.xq5)
    }
    if (element.xq6.Checkbox === true) {
      element.xq6.kssj = element.kssj
      element.xq6.jssj = element.jssj
      truebox.value.push(element.xq6)
    }
    if (element.xq7.Checkbox === true) {
      element.xq7.kssj = element.kssj
      element.xq7.jssj = element.jssj
      truebox.value.push(element.xq7)
    }
  })
  kcids.value = []
  truebox.value.forEach((jskc) => {
    kcids.value.push(jskc.kcid)
  })
}
// 布置作业
const openAddBzzy = ref(false)
const openAddBuZhiZuoYe = ref(false)
const openDetailbzzy = ref(false)
const addzy = (val) => {
  huoQuYiXuanKeCheng()
  if (kcids.value.length < 1) {
    return warningPrompt('请选择课程')
  } else if (kcids.value.length > 1) {
    return warningPrompt('只能选择一个课程')
  } else if (truebox.value[0].sfbzzy === true) {
    return warningPrompt('作业已上传')
  } else {
    chechboxtrue.value = truebox.value
    if (val === 1) {
      openAddBuZhiZuoYe.value = true
    } else {
      openAdd.value = true
      openAddBzzy.value = true
    }
    row.value = {
      title: '布置作业',
      xqid: xqid.value,
      xqmc: xqmc.value,
      zc: zcid.value,
      chechboxtrue: truebox.value
    }
  }
}
// 教学日志
const openAddJxrz = ref(false)
const openAddJiaoXueRiZhi = ref(false)
const openDetailJxrz = ref(false)
const addjxrz = (val) => {
  huoQuYiXuanKeCheng()
  if (kcids.value.length < 1) {
    return warningPrompt('请选择课程')
  } else if (kcids.value.length > 1) {
    return warningPrompt('只能选择一个课程')
  } else if (truebox.value[0].sfscjxrz === true) {
    return warningPrompt('教学日志已上传')
  } else {
    if (val === 1) {
      openAddJiaoXueRiZhi.value = true
    } else {
      openAdd.value = true
      openAddJxrz.value = true
    }
    row.value = {
      xqid: xqid.value,
      xqmc: xqmc.value,
      zc: zcid.value,
      chechboxtrue: truebox.value[0]
    }
  }
}

// 教师课表结构数据
const bxscs = ref(0) // 必须上传
const yjscs = ref(0) // 教学设计已经上传数
const ysckjs = ref(0) // 课件已经上传数
const ybks = ref(0) // 已备课数
const yscjxrzs = ref(0) // 教学日志已上传数
const ybzzys = ref(0) // 已布置作业数
const getjslistdata = () => {
  loading.value = true
  const obj = {
    xqid: xqid.value,
    zc: zcid.value
  }
  const o = {
    url: '/api/v2/jiaowu/jiaowujiaoxuesheji/jiaoshijiaoxueshejikejian',
    data: obj
  }
  actionPost(o).then((res) => {
    loading.value = false
    jslistdata.value = res.data
    if (res.data.length) {
      bxscs.value = res.data[0].bxscs
      yjscs.value = res.data[0].yjscs
      ysckjs.value = res.data[0].ysckjs
      ybks.value = res.data[0].ybks
      yscjxrzs.value = res.data[0].yscjxrzs
      ybzzys.value = res.data[0].ybzzys
      getkebiaojiegou()
    }
  })
}
// 获取周次
const getzouci = () => {
  const o = {
    url: '/api/v2/jiaowu/jiaowuxiaoli/xiaoLiRiQi',
    data: { xqid: xqid.value }
  }
  const zcs = []
  allzc.value = []
  actionPost(o).then((res) => {
    if (res.data) {
      res.data.forEach((item) => {
        if (zcs.indexOf(item.zc) === -1) {
          zcs.push(item.zc)
          allzc.value.push(item)
        }
        if (item.rq === getDate('YYYY', 'MM', 'DD')) {
          zcid.value = item.zc
        }
      })
      getjslistdata()
    }
  })
}

// 学期发生了改变
const xveqichaxvn = (e) => {
  xqmc.value = e.xqmc
  getzouci()
  getjslistdata()
}
// 周次发生了改变
const zhouci = () => {
  getjslistdata()
}
// 分析时段
const xvk = (data) => {
  merge.value = []
  for (let i = 0; i < data.length; i++) {
    if (i === 0) {
      merge.value.push(1)
      pos.value = 0
    } else {
      // 判断当前元素与上一个元素是否相同
      // 根据相同id进行合并,根据需要可进行修改
      if (data[i].sd === data[i - 1].sd) {
        merge.value[pos.value] += 1
        merge.value.push(0)
      } else {
        merge.value.push(1)
        pos.value = i
      }
    }
  }
}
const dSpanCellMerge = ({ rowIndex, columnIndex }) => {
  if (columnIndex === 0) {
    const _row = merge.value[rowIndex]
    const _col = _row > 0 ? 1 : 0
    return {
      rowspan: _row,
      colspan: _col
    }
  }
}
const openList = ref(false)
watch(
  () => props.open,
  () => {
    if (props.open === 'jiaoxuesheji') {
      openList.value = true
      getkebiaojiegou()
      getxqlist()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
:deep(.el-form) {
  width: 99%;
}
</style>
